import { useRef, useState } from "react";

// Hydration and automatic defaults are not user edits. Freeze the baseline at
// the first interaction, then compare the actual editable values (including pickers).
export default function useDocumentDraft(values, resetKey) {
  const snapshot = JSON.stringify(values);
  const state = useRef({ key: resetKey, baseline: snapshot, touched: false });
  const [, refresh] = useState(0);
  if (state.current.key !== resetKey) state.current = { key: resetKey, baseline: snapshot, touched: false };
  if (!state.current.touched) state.current.baseline = snapshot;
  const interact = () => {
    if (!state.current.touched) { state.current.touched = true; refresh(n => n + 1); }
  };
  const saved = () => { state.current.baseline = snapshot; state.current.touched = false; refresh(n => n + 1); };
  return { dirty: state.current.touched && snapshot !== state.current.baseline, interact, saved };
}
